import { render } from "./PipGallery.vue?vue&type=template&id=cd78a938"
import script from "./PipGallery.vue?vue&type=script&lang=js"
export * from "./PipGallery.vue?vue&type=script&lang=js"

import "./PipGallery.vue?vue&type=style&index=0&id=cd78a938&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__